import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = ({
  path,
  user,
  component: Component,
  render,
  ...rest
}) => {
  //default return component
  const Page = (props) =>
    Component ? <Component {...props} /> : render({ ...props, user });

  //user permission checks
  const usercheck = user && Object.keys(user).length > 0;
  const superuser = usercheck && user['is_superuser'];
  const userspage = !superuser && path.includes('users');

  //Main return
  return (
    <Route
      path={path}
      {...rest}
      render={(props) => {
        if (!usercheck)
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: props.location }
              }}
            />
          );
        if (userspage) return <Redirect to={{ pathname: '/not-found' }} />;
        return Page(props);
      }}
    ></Route>
  );
};

export default ProtectedRoute;
